import './BarChartEntry.scss';
import { FC } from 'react';
import { BarChartEntryBar } from './BarChartEntryBar';
import { BarChartEntryValue } from './BarChartEntryValue';

type Formatter = (value: number) => string;

interface Props {
  visibleIndex: number;
  primaryMax: number;
  primaryValue: number;
  secondaryMax: number;
  secondaryValue: number;
  isPrimary: boolean;
  primaryFormatterFn: Formatter;
  secondaryFormatterFn: Formatter;
}

export const BarChartEntry: FC<Props> = ({
  visibleIndex,
  primaryMax,
  secondaryMax,
  primaryValue,
  secondaryValue,
  isPrimary,
  primaryFormatterFn,
  secondaryFormatterFn,
}) => {
  const cn = 'bar-chart-entry__x';
  const primaryCn = `${cn}-primary`;
  const secondaryCn = `${cn}-secondary`;
  const activeCn = `${cn}-active`;
  const inactiveCn = `${cn}-inactive`;
  return (
    <div className="bar-chart-entry">
      <div className="bar-chart-entry__bars-wrapper">
        <BarChartEntryBar
          activeClassName="bar-chart-entry__bar-primary"
          value={primaryValue}
          max={primaryMax}
          isActive={isPrimary}
          stagger={0.1}
          visibleIndex={visibleIndex}
        />
        <div className="bar-chart-entry__second-bar">
          <BarChartEntryBar
            activeClassName="bar-chart-entry__bar-secondary"
            value={secondaryValue}
            max={secondaryMax}
            isActive={!isPrimary}
            stagger={0.1}
            visibleIndex={visibleIndex}
          />
        </div>
      </div>
      <div className={`${primaryCn} ${isPrimary ? activeCn : inactiveCn}`}>
        <BarChartEntryValue
          value={primaryValue}
          formatterFn={primaryFormatterFn}
          isVisible={visibleIndex !== -1}
          isPrimary={isPrimary}
        />
      </div>
      <div className={`${secondaryCn} ${isPrimary ? inactiveCn : activeCn}`}>
        <BarChartEntryValue
          value={secondaryValue}
          formatterFn={secondaryFormatterFn}
          isVisible={visibleIndex !== -1}
          isPrimary={isPrimary}
        />
      </div>
    </div>
  );
};
